import { Immutable } from "immer";
import React, { useEffect } from "react";
import { Link } from "tsi-common-react/src/components/Link/index";
import { ProductUUID } from "tsi-common-react/src/models/nominals";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import { IReduxState } from "../../../store/reducers.interfaces";
import { Store } from "../Store";
import { setSelectedProduct } from "../reducers";
import { storesWithSelectedProductInStockSelector } from "../selectors";

type IProps = Immutable<{
    product: ProductUUID;
}>;

export const NearbyStoresProduct = (props: IProps): React.ReactNode => {
    const dispatch = useAppDispatch();
    const stores = useAppSelector((state) =>
        storesWithSelectedProductInStockSelector(state as IReduxState),
    );
    const findARetailerURL = usePageURL("find_a_retailer");

    useEffect(() => {
        if (props.product) {
            dispatch(setSelectedProduct(props.product));
        }
    }, [props.product]);

    const renderStores = () => {
        if (stores.length === 0) {
            return null;
        }
        // Limit to displaying 2 stores
        const limitedStores = stores.slice(0, 2);
        return (
            <ul className="pdp-modal-stores">
                {limitedStores.map((store) => {
                    return <Store key={`${store.external_id}`} store={store} />;
                })}
            </ul>
        );
    };

    return (
        <div>
            {renderStores()}
            <div className="pdp-modal-store__footer">
                <Link
                    className="pdp-modal__link al-more-ways-to-buy-see_all"
                    href={findARetailerURL}
                >
                    {t`See all Retailers`}
                </Link>
            </div>
        </div>
    );
};
